import { createFormatter } from 'reacticoon/format'

import isEmpty from 'lodash/isEmpty'
import { formatUser } from 'modules/user/format'

export const formatUserMe = createFormatter((userMe) => {
  userMe.hasLinkedDiscord = !isEmpty(userMe.discordId)
  return userMe
}, formatUser)
